import { render, staticRenderFns } from "./BookingReviewSummary.vue?vue&type=template&id=4a189466&scoped=true&"
import script from "./BookingReviewSummary.vue?vue&type=script&lang=js&"
export * from "./BookingReviewSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingReviewSummary.vue?vue&type=style&index=0&id=4a189466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a189466",
  null
  
)

export default component.exports